var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkrgasbankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241.8,
    height: 41.5,
    viewBox: "0 0 241.8 41.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#005495}.cls-2{fill:#59aa47}.cls-3{fill:#005496}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-59.3 -33.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M238.7 56.4h.3a2.787 2.787 0 0 0 1-.1h.4l-.2-.3-2.8-4.9-.4.2 1.7 4.9zm-11.1-8.3a3.771 3.771 0 0 0 2-2.5v.8a18.7 18.7 0 0 0 .3 3.4 3.728 3.728 0 0 0-2.3-1.7M168 54.7l-5-6.7 5-6.6zm70.4-8.2c1.2 0 2 .9 2 2.4a2.09 2.09 0 0 1-1.5 2.3l-.3.1.2.3 2.5 4.5.1.2h.2a7.458 7.458 0 0 0 5.8-6.4c.5 4.4 3.6 6.7 6.7 6.7a6.033 6.033 0 0 0 4.4-1.7V56h6.8V41h-6.6v7.3a2.347 2.347 0 0 1-2.3 2.6 2.3 2.3 0 0 1-2.3-2.6 2.4 2.4 0 0 1 2.3-2.6h.4l-.2-.3-2.9-5-.1-.1h-.1c-3.3.3-5.7 3-6.1 6.8a6.643 6.643 0 0 0-6.9-5.8 6.978 6.978 0 0 0-4.7 1.5c.7-2.3 2.8-3 6.1-3.7 1.9-.4 5.1-1.1 5.2-5.4v-.2h-5.4v.2c-.1.5-.7.7-2.1 1-.6.1-1.4.3-2.3.5-4.4 1.1-6.9 4.2-7.4 9.2-.2-2.5-2.8-4-6.8-4a18.385 18.385 0 0 0-6.2 1.1V41H210v7.3a2.347 2.347 0 0 1-2.3 2.6 2.3 2.3 0 0 1-2.3-2.6 2.4 2.4 0 0 1 2.3-2.6h.4l-.2-.3-2.9-5-.1-.1h-.1c-3.7.3-6.2 3.6-6.2 8a11.02 11.02 0 0 0 .2 1.8 18.3 18.3 0 0 1-5.1 1.6c-1.3 0-1.3-.5-1.3-.6 0-.3 0-.7 1.3-.9 2.3-.4 4.7-1.2 4.7-4.6 0-2.6-1.8-5.4-6.7-5.4a12.234 12.234 0 0 0-5.7 1.4l-.2.1.1.2 1.6 3.3.1.2.2-.1a5.144 5.144 0 0 1 2.8-.9c1.3 0 1.4.6 1.4.8 0 .6-.7.8-1.7.9a.6.6 0 0 0-.4.1c-2 .3-3.3 1.2-3.8 2.7v-.7c0-5.2-3.4-8-6.8-8a6.458 6.458 0 0 0-4.6 1.8v-1h-14.4l-.1.1-2.9 5.1V41h-11.5l-.1.2-2 5.7-2.8-5.7.1-.2h-8l.2.3 7.4 12.5-3.6 7.4-.2.3h7.2l.1-.1 6.4-14.7v9h7V50l3.2 5.6.1.1h7.3v5.8h6.7V48.3a2.347 2.347 0 0 1 2.3-2.6 2.406 2.406 0 0 1 2.3 2.6 2.333 2.333 0 0 1-2.2 2.6h-.4l.2.3 3.1 4.9.1.1h.1c2.8-.3 4.9-2.4 5.7-5.4 0 1.6.7 5.4 7.2 5.4a14.258 14.258 0 0 0 7.6-2.3 6.211 6.211 0 0 0 4.9 2.3 6.032 6.032 0 0 0 4.4-1.7v1.1h6.8V45.5a13.808 13.808 0 0 1 5.2-.9c1.3 0 1.9.3 1.9 1 0 .4-.5.7-1.3.7h-2.9v3.9h2.7c1.1 0 1.6.2 1.6.7s-.5 1-1.6 1a8.542 8.542 0 0 1-4.1-1.3l-.4-.2v5.4l.2.1a15.724 15.724 0 0 0 4.9.8c5.6 0 7.6-2.5 7.6-4.7a7.6 7.6 0 0 0 5.6 4.5l.3.1v-7.7c-.1-1.5.6-2.4 1.8-2.4m62.4 8.9l-5.5-7.4 4.9-6.6.3-.4h-8l-.1.1-2.8 5.1V41h-7v14.7h7V50l3.2 5.6.1.1h8.2zm-43-8.8l.4-.2-1.8-5.3V41h-.1a8.331 8.331 0 0 0-1.5-.4l-.5-.1.2.4zM99.1 58.9c-.2-.1-.8-.5-.8-1.8 0-1.1 1.2-2.3 2.6-3.7 2-2 4.2-4.2 4.2-7.3a16.721 16.721 0 0 0-1.1-5.7l18.1 8.7zm.3-24.5l-.8-.4.5.7s2.9 4.4 2.9 8.3c0 3.6-2 5.6-3.9 7.4-1.8 1.8-3.7 3.7-3.7 6.9a9.177 9.177 0 0 0 2.2 5.9l.1.1.1-.1 32.3-13.8.5-.2-.4-.2zM78.1 51.1c0-2.8 4.8-5.1 6.6-5.9a10.7 10.7 0 0 0-1.8 5.8 10.53 10.53 0 0 0 2.1 5.8c-1.9-.5-6.9-2.5-6.9-5.7m17.6-2.4c1.7-2.4 3.5-4.9 3.5-7.1 0-3.5-3.5-7.4-3.6-7.6l-.1-.1-.1.1-35.6 15-.5.2.5.2 31.8 12.8.2-.4c-.1-.1-5.4-5.4-5.4-9.7 0-3.5 1.9-5.2 3.8-6.8a11.808 11.808 0 0 0 3.2-3.8 8.323 8.323 0 0 0 .5-3.2 4.5 4.5 0 0 1 1.4 3.4c0 1.5-1.3 3.4-2.7 5.4-1.6 2.3-3.3 4.6-3.3 6.8 0 4.1 5 9.6 5.2 9.8l.4-.3c0-.1-2.4-4.8-2.4-8.5.1-1.7 1.6-3.9 3.2-6.2m113.7-2.1l.4-.2L208 41v-.1h-.1a8.331 8.331 0 0 0-1.5-.4l-.5-.1.2.4zm-33.5 4.3l-.4.2 1.7 4.9v.1h.1c.4.1.9.2 1.4.3h.4l-.2-.4zm96.6 4.9h.2v-5.1h2.2v5.1h7V41h-7v4.5h-2.2V41h-7v14.7h6.8z",
    className: "cls-1",
    "data-name": "Path 8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M274.8 59.3a5.811 5.811 0 0 1-1.7 1.7c-1.9 1-3.1.8-4.6 2.2a4.674 4.674 0 0 0-1.2 2.9c0 .3-.1.6-.1.8 0-.1 0-.1.1-.2.1-.2.1-.3.2-.5s.2-.3.3-.5a3.044 3.044 0 0 1 .8-.8 3.7 3.7 0 0 1 1.1-.5c.4-.1.7-.2 1.1-.3a2.935 2.935 0 0 0 1-.3 3.552 3.552 0 0 0 .9-.4c.1-.1.3-.2.4-.3.1 0 .1-.1.2-.1l.1-.1c.2-.2.3-.4.5-.6l.1-.1.1-.1a.31.31 0 0 0 .1-.2 1.01 1.01 0 0 0 .2-.5v.1c0 .1-.1.2-.1.4 0 .1-.1.2-.1.3a.1.1 0 0 1-.1.1.31.31 0 0 1-.1.2 5.739 5.739 0 0 1-.4.7 4.62 4.62 0 0 1-.7.7 4.054 4.054 0 0 1-.9.5c-.3.1-.7.2-1.1.3s-.7.2-1.1.3a2.471 2.471 0 0 0-.9.4 4.351 4.351 0 0 0-.7.6c-.1.1-.2.3-.3.4a.758.758 0 0 0-.2.4c-.1.1-.1.3-.2.4 0 .1-.1.3-.1.4s-.1.3-.1.4-.1.2-.1.3c0 .2-.1.4-.1.6v.3l.2.2a3.5 3.5 0 0 1 1.1-2c1-.8 2.3-.6 3.5-.9a4.135 4.135 0 0 0 2.8-2 6.068 6.068 0 0 0 .5-4.4c-.2-.1-.3-.5-.4-.8z",
    className: "cls-2",
    "data-name": "Path 9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M284.3 74.7h3.2v-2.5h1.3v2.5h3.2v-6.9h-3.2V70h-1.3v-2.2h-3.2z",
    className: "cls-3",
    "data-name": "Path 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M292.4 74.7h3.2v-3l1.7 3h3.7l-2.7-3.6 2.4-3.3h-3.5l-1.6 2.8v-2.8h-3.2z",
    className: "cls-3",
    "data-name": "Path 11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M271.3 75l-.8-2.4 1.4 2.3a1.268 1.268 0 0 1-.6.1",
    className: "cls-3",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M280.5 70.3l-1.6-2.8a1.445 1.445 0 0 1 .7.2z",
    className: "cls-3",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M279.6 69.9a1.24 1.24 0 0 0-1.2 1.3 1.272 1.272 0 0 0 1.2 1.4c.7 0 1.2-.5 1.2-1.4v-3.4h3v6.9h-3.1V74a2.853 2.853 0 0 1-2.2 1c-1.6 0-3.1-1.3-3.1-3.7 0-2 1.2-3.6 2.9-3.7z",
    className: "cls-3",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M271.9 68a2.692 2.692 0 0 0-2.4 1 4.094 4.094 0 0 0-2.3-.8 6.648 6.648 0 0 0-.3 2.1c0 1.1.2 4 3.1 4.6v-3.4c0-.8.4-1.3 1-1.3.7 0 1.1.5 1.1 1.3 0 .7-.3 1.1-.8 1.2l1.2 2.2a3.5 3.5 0 0 0 2.7-3.6 3.191 3.191 0 0 0-3.3-3.3z",
    className: "cls-3",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M244.9 74.6h3.2v-3.1l1.7 3.1h3.7l-2.7-3.7 2.4-3.3h-3.5l-1.6 2.9v-2.9h-3.2z",
    className: "cls-2",
    "data-name": "Path 16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M242 72.5l1.2 2c.2-.1.3-.2.5-.3l-1.7-1.7z",
    className: "cls-2",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M241 73.1a1.155 1.155 0 0 1-1.1-1.3h5.1c0-1.5-.4-4.5-4.1-4.5a3.761 3.761 0 0 0-4.1 3.8 3.621 3.621 0 0 0 4 3.8 4.844 4.844 0 0 0 1.8-.3l-1-1.7a.845.845 0 0 1-.6.2zm0-4a1.131 1.131 0 0 1 1.1 1.2H240a1.108 1.108 0 0 1 1-1.2z",
    className: "cls-2",
    "data-name": "Path 18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M255.9 72.1l.9 2.8a1.483 1.483 0 0 0 .7-.1z",
    className: "cls-2",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M256.5 67.3c-3 0-4.2 1.8-4.2 3.8a3.632 3.632 0 0 0 3.2 3.7V71a1.1 1.1 0 0 1 1.1-1.1 1.122 1.122 0 0 1 1.1 1.2 1.146 1.146 0 0 1-1 1.2l1.5 2.4a3.5 3.5 0 0 0 2.7-3.6c-.1-2-1.4-3.8-4.4-3.8z",
    className: "cls-2",
    "data-name": "Path 20"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    className: "cls-2",
    "data-name": "Ellipse 4",
    transform: "translate(262.4 69.8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkrgasbankLogo);
export default __webpack_public_path__ + "static/media/Ukrgasbank_logo.a3fd5fc80117f9ed635c943428931aaa.svg";
export { ForwardRef as ReactComponent };